import { useState } from "react";
import { Power } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const ProductShowcase = () => {
  const { t } = useLanguage();
  const [on, setOn] = useState(false);
  const features = ["f1", "f2", "f3", "f4"];

  return (
    <section
      id="produit"
      data-testid="product-showcase"
      className="relative py-20 sm:py-32 lg:py-40 bg-[#0a0a0a] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 sm:gap-16 items-center">
          <div className="lg:col-span-5 lg:col-start-1 order-2 lg:order-1">
            <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">{t("showcase.label")}</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#f4ede0] mt-4 sm:mt-6 mb-6 sm:mb-8 leading-[1.05]">
              {t("showcase.title1")}<br />
              <span className="italic copper-text">{t("showcase.title2")}</span>
              {t("showcase.title3")}
            </h2>
            <p className="text-[#cbc1ad] text-base leading-relaxed mb-10 max-w-md">{t("showcase.desc")}</p>

            <button
              data-testid="lcd-toggle-button"
              onClick={() => setOn((v) => !v)}
              className={`group inline-flex items-center gap-4 border px-7 py-4 text-sm uppercase tracking-[0.22em] transition-all ${
                on ? "border-[#d89557] bg-[#b87333]/10 text-[#f3c98a]" : "border-[#2a2422] text-[#cbc1ad] hover:border-[#b87333] hover:text-[#d89557]"
              }`}
            >
              <Power className={`w-4 h-4 transition ${on ? "text-[#d89557]" : ""}`} />
              {on ? t("showcase.modeOn") : t("showcase.modeOff")}
            </button>

            <div className="grid grid-cols-2 gap-6 mt-12 max-w-md">
              {features.map((k) => (
                <div key={k} className="border-l border-[#b87333]/40 pl-4">
                  <h4 className="font-display text-lg text-[#f4ede0] mb-1">{t(`showcase.features.${k}.t`)}</h4>
                  <p className="text-xs text-[#7a716a] leading-relaxed">{t(`showcase.features.${k}.d`)}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="relative aspect-[5/4] lcd-frame select-none" onContextMenu={(e) => e.preventDefault()}>
              <div
                className="absolute inset-0 bg-cover bg-center pointer-events-none"
                style={{
                  backgroundImage:
                    "url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1600&q=80')",
                }}
              />
              <div className={`lcd-pane absolute inset-0 ${on ? "transparent" : "frosted"}`} />
              <div className="absolute top-6 left-6 flex items-center gap-2 px-3 py-1.5 bg-[#0a0a0a]/60 backdrop-blur border border-[#b87333]/30">
                <div className={`w-1.5 h-1.5 rounded-full ${on ? "bg-[#d89557]" : "bg-[#7a716a]"}`} />
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#cbc1ad]">{on ? "ON" : "OFF"}</span>
              </div>
              <div className="absolute bottom-6 right-6 font-display italic text-[#f4ede0]/80 text-2xl">
                {on ? t("showcase.stateOn") : t("showcase.stateOff")}
              </div>
              {/* Watermark fantôme */}
              <img
                src="/brand/smartxglass-logo.png"
                alt=""
                aria-hidden="true"
                className="absolute bottom-4 right-4 h-12 sm:h-16 w-auto opacity-30 mix-blend-screen pointer-events-none select-none"
                draggable="false"
              />
            </div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#7a716a] mt-4 text-center">
              {t("showcase.tip")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
